import React from 'react';
import { DefaultDateRange } from '../../components/secondary/date-ranges';
import { BenchmarkType } from '../../components/secondary/benchmark-type';
import { Block } from '../../components/core';
import { useRecoilValue } from 'recoil';
import { blockDateRange, blockDisplayHeader, customizedBlock } from 'venn-state';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';

export const DistributionHeader = ({ id }: { id: string }) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const dateRange = useRecoilValue(blockDateRange(id));
  const block = useRecoilValue(customizedBlock(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {block.subHeader && <Block.SubHeadline id={id}>{block.subHeader}</Block.SubHeadline>}
        </Block.Title>
        <Block.Metadata id={id}>
          <DefaultDateRange dateRange={dateRange} />
          <BenchmarkType id={id} />
          {block.relativeToBenchmark && (
            <Block.MetadataItem iconType="calculator">Relative to Benchmark</Block.MetadataItem>
          )}
        </Block.Metadata>
      </Block.HeaderTopContainer>
      <DefaultSubjects
        id={id}
        metric={block.selectedMetrics[0] || ''}
        relativeToBenchmark={block.relativeToBenchmark}
      />
    </>
  );
};
